import * as React from 'react';
import { ICwsProductFeaturesViewProps } from './cws-product-features';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { CommerceProperty } from '@msdyn365-commerce/retail-proxy';

export default (
    props: ICwsProductFeaturesViewProps & {
        extensionProps?: CommerceProperty[];
    }
) => {
    const extensionProps = props.extensionProps || [];

    const featureProp = extensionProps[0];
    const featureHtml = typeof featureProp?.Value === 'string' ? featureProp.Value : featureProp?.Value?.StringValue;

    if (!featureHtml) {
        return null;
    }

    return (
        <Node className='cws-product-features'>
            <div className='cws-product-features__content' dangerouslySetInnerHTML={{ __html: featureHtml }} />
        </Node>
    );
};
